const t = {
  "contact-person": "contact-person",
  "contact-person__avatar": "contact-person__avatar",
  "contact-person__name": "contact-person__name",
  "contact-person__job-title": "contact-person__job-title",
  "contact-person__phone-number": "contact-person__phone-number",
  "contact-person__email-address": "contact-person__email-address"
};
export {
  t as default
};
